import { render, staticRenderFns } from "./GroupSubscribers.vue?vue&type=template&id=4ca3327e&scoped=true&"
import script from "./GroupSubscribers.vue?vue&type=script&lang=js&"
export * from "./GroupSubscribers.vue?vue&type=script&lang=js&"
import style0 from "./GroupSubscribers.vue?vue&type=style&index=0&id=4ca3327e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca3327e",
  null
  
)

export default component.exports